export function getExternalRevisionDisplay(value?: string | null): string {
  if (typeof value !== 'string') {
    return '-';
  }

  const normalized = value.trim();
  return normalized === '' ? '-' : normalized;
}
